import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBatchUploaded = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 121,
	height: 120,
	viewBox: "0 0 121 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_12030_17866)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				filter: "url(#filter0_d_12030_17866)",
				children: [
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter1_d_12030_17866)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M45.7534 21.0495C42.0074 21.0495 38.9707 24.0862 38.9707 27.8322V82.0936C38.9707 85.8395 42.0074 88.8763 45.7534 88.8763H87.2973C91.0432 88.8763 94.0799 85.8395 94.0799 82.0936L94.0428 27.0021C94.0405 23.6876 91.3511 21.0028 88.0366 21.0062L45.7534 21.0495Z",
							fill: "url(#paint0_linear_12030_17866)"
						})
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M55.2134 48.9131C54.5451 48.9131 54.0034 49.4549 54.0034 50.1231C54.0034 50.7913 54.5451 51.333 55.2134 51.333H62.9048C63.573 51.333 64.1148 50.7913 64.1148 50.1231C64.1148 49.4549 63.573 48.9131 62.9048 48.9131H55.2134Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M54.0034 59.8027C54.0034 59.1344 54.5451 58.5927 55.2134 58.5927H76.7465C77.4148 58.5927 77.9565 59.1344 77.9565 59.8027C77.9565 60.4709 77.4148 61.0126 76.7465 61.0126H55.2134C54.5451 61.0126 54.0034 60.4709 54.0034 59.8027Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M55.2134 53.7529C54.5451 53.7529 54.0034 54.2946 54.0034 54.9629C54.0034 55.6311 54.5451 56.1728 55.2134 56.1728H76.9924C77.6606 56.1728 78.2023 55.6311 78.2023 54.9629C78.2023 54.2946 77.6606 53.7529 76.9924 53.7529H55.2134Z",
						fill: "white"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				filter: "url(#filter2_dii_12030_17866)",
				children: [/* @__PURE__ */ _jsx("ellipse", {
					cx: 41.642,
					cy: 83.3301,
					rx: 15.642,
					ry: 15.168,
					fill: "#F7F8FA",
					shapeRendering: "crispEdges"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M41.642 100.517C51.3366 100.517 59.3025 92.8801 59.3025 83.3301C59.3025 73.7801 51.3366 66.1435 41.642 66.1435C31.9473 66.1435 23.9814 73.7801 23.9814 83.3301C23.9814 92.8801 31.9473 100.517 41.642 100.517Z",
					stroke: "#E9E6E6",
					strokeOpacity: .3,
					strokeWidth: 4.0372,
					shapeRendering: "crispEdges"
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M47.239 79.8853L41.6082 85.3454C40.7984 86.1307 39.5021 86.0998 38.7305 85.2768L36.9052 83.3298",
				stroke: "#3DD394",
				strokeWidth: 3.02768,
				strokeLinecap: "square"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_12030_17866",
			x: 18.8764,
			y: 7.60992,
			width: 95.2979,
			height: 108.059,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 6.69812 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 10.0472 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.08 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_12030_17866"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_12030_17866",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter1_d_12030_17866",
			x: 34.9707,
			y: 18.0061,
			width: 67.1093,
			height: 79.8701,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 2,
					dy: 3
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_12030_17866"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_12030_17866",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter2_dii_12030_17866",
			x: 13.4847,
			y: 57.6654,
			width: 68.4261,
			height: 67.4781,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feMorphology", {
					radius: 2.0186,
					operator: "erode",
					in: "SourceAlpha",
					result: "effect1_dropShadow_12030_17866"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 6.05579,
					dy: 8.07439
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 8.27625 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_12030_17866"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_12030_17866",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: -4.0372,
					dy: -4.0372
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.0372 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "shape",
					result: "effect2_innerShadow_12030_17866"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 4.0372,
					dy: 4.0372
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.0372 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect2_innerShadow_12030_17866",
					result: "effect3_innerShadow_12030_17866"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_12030_17866",
			x1: 42.8283,
			y1: 16.5022,
			x2: 107.495,
			y2: 90.2581,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#ABE7CE" }), /* @__PURE__ */ _jsx("stop", {
				offset: .562838,
				stopColor: "#3DD394"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_12030_17866",
			children: /* @__PURE__ */ _jsx("rect", {
				x: .5,
				width: 120,
				height: 120,
				rx: 60,
				fill: "white"
			})
		})
	] })]
});
export default SvgBatchUploaded;
